<div class="photo-upload" [ngClass]="[!layout ? 'layout-1' : 'layout-2']">
  @if (reload) {
    <div
      class="photo-thumbnail"
      [ngStyle]="{ 'padding-bottom': heightRatioInPercent }"
      [lazyLoad]="previewUrl"
      [ngClass]="[media?.url1x || photo ? 'photo-loaded' : '']"
    >
      @if (showFullImg && (media?.url1x !== '' || photo !== '')) {
        <img class="bg-img" [src]="previewUrl" />
      }
      @if (loading) {
        <div class="spinner-container p-absolute">
          <mat-spinner class="dark" [diameter]="20"></mat-spinner>
        </div>
      }
      @if (sign) {
        <span class="sign">{{ sign }}</span>
      }
      @if (!loading) {
        <div class="btn-container" [ngClass]="{ active: media?.url1x || photo }">
          <button type="button" class="btn btn-photo" (click)="inputFile.click()">
            <!-- <span class="text">{{ 'global.' + uploadTxt | transloco }}</span> -->
            <span class="icon-photo" [inlineSVG]="'/icons/icon-photo.svg'"></span>
          </button>
          @if (cropPhoto && (media || photo)) {
            <button type="button" class="btn btn-crop-photo" (click)="cropThisPhoto()">
              <span class="text">{{ 'global.' + cropImgtxt | transloco }}</span>
              <span class="icon-photo" [inlineSVG]="'/icons/icon-photo.svg'"></span>
            </button>
          }
          @if (media || photo) {
            <button type="button" class="btn btn-remove" (click)="removePhoto()">
              <span class="icon icon-trash" [inlineSVG]="'/icons/icon-trash.svg'"></span>
            </button>
          }
          <input #inputFile type="file" (change)="onFileChange($event)" accept=".jpg,.png,.jpeg" />
        </div>
      }
    </div>
  }
  @if (error) {
    <div class="error">
      {{ 'form.error.' + error | transloco }}
    </div>
  }
  @if (!hideInfo) {
    <div class="info">
      @if (!disableFileSizeNote) {
        {{ uploadFileSizeNote | transloco }} <strong>{{ maxFileSize }}Mb</strong>.
      }
      @if (!disableImgNote) {
        {{ uploadImgNote | transloco }} <strong>{{ maxImgRes }}px</strong>
      }
      @if (extraNote) {
        {{ extraNote | transloco: { maxSize: maxImgRes } }}
      }
    </div>
  }
  <div class="info"><ng-content></ng-content></div>
</div>
